<template>
    <div ref="unitEntryByRegion" style="min-height: 400px;"></div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data () {
            return {
                chart : null,
            }
        },
        props : ['data'],
        mounted () {
            this.createChart();
            this.generateData();
        },
        watch : {
            data : {
                deep : true,
                handler : 'generateData'
            }
        },
        methods : {
            generateData () {
                let length = this.chart.data.length;
                let data = JSON.parse(JSON.stringify(this.data));

                //Sort data
                data.sort((a,b) => (a.count > b.count) ? 1 : ((b.count > a.count) ? -1 : 0)).reverse();

                this.chart.addData(data && data.length > 0 ? data : [{region:'No Data', count:0}], length)
            },
            createChart () {/* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.unitEntryByRegion, am4charts.XYChart);

                // Create axes
                let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "region";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.minGridDistance = 30;

                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;

                // Create series
                let series = this.chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = "count";
                series.dataFields.categoryX = "region";
                series.name = "count";
                series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
                series.columns.template.fillOpacity = .8;

                let columnTemplate = series.columns.template;
                columnTemplate.strokeWidth = 2;
                columnTemplate.strokeOpacity = 1;
            }
        }
    }
</script>

<style scoped>

</style>